import { Handler } from '../../../Shared/Application/UseCases/Handler';
import StoreSearchRepository from '../../Infrastructure/StoreSearchRepository';
import ConfigurationAdapter from '../../../../config/ConfigurationAdapter';
/**
 * TODO: Putting use case and handlers on same file seems like a good idea, but further analysis is needed.
 * It may be possible to simplify into a single class here and once we have a final design it has to be applied to
 * the other use cases
 */
export const GetProductsByCriteriaUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetProductsByCriteriaHandler(new StoreSearchRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService));
};
class GetProductsByCriteriaHandler extends Handler {
  constructor(storeSearchRepository) {
    super();
    this.storeSearchRepository = storeSearchRepository;
  }
  handle(criteria) {
    return this.storeSearchRepository.findByCriteria(criteria);
  }
}
